<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-competition-participant-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
            </button>

            <h4 class="modal-title">
              Create Participant
            </h4>
          </div>

          <div class="modal-body">
            <TypeaheadFormGroup
                v-model="data.user_id"
                name="user_id"
                label="User"
                endpoint="/api/v2/users"
                :token="shared.token"
                path="data.data"
                placeholder="Search..."
                :result-label-property="row => row.attributes.full_name"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import store from '@/store'
import Errors from '@/mixins/Errors'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Block/Typeahead'

export default {
  components: { TypeaheadFormGroup},

  mixins: [Errors],

  props: {
    competitionTeam: {
      required: true
    }
  },

  data() {
    return {
      data: {},

      shared: store,
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/competition-participants', {...this.data, competition_team_id: this.competitionTeam.id})
          .then(() => {
            notify.success('The participant was saved')

            this.$emit('created')

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
